import React from 'react';
import { FiChevronDown, FiUser, FiUsers } from 'react-icons/fi';
import '../styles/UserSelectModal.css';

const UserSelectTrigger = ({ selectedUser, onClick, disabled = false }) => {
  // Get avatar background color based on role
  const getAvatarColorClass = (role) => {
    switch (role) {
      case 'Partner':
        return 'avatar-partner';
      case 'Staff Mgr':
        return 'avatar-manager';
      case 'Staff':
        return 'avatar-staff';
      default:
        return '';
    }
  };

  return (
    <button 
      className="user-select-trigger" 
      onClick={onClick}
      disabled={disabled}
    >
      <div className="user-select-trigger-text">
        {selectedUser ? (
          <>
            {selectedUser.id ? (
              <div className={`user-select-selected-avatar ${getAvatarColorClass(selectedUser.role)}`}>
                {selectedUser.username.charAt(0).toUpperCase()}
              </div>
            ) : (
              <div className="user-select-selected-avatar all-users">
                <FiUsers />
              </div>
            )}
            <span>{selectedUser.username}</span>
            {selectedUser.role && (
              <span className={`user-select-trigger-role role-partner`}>
                {selectedUser.role}
              </span>
            )}
          </>
        ) : (
          <>
            <div className="user-select-selected-avatar">
              <FiUser />
            </div>
            <span>Select a user</span>
          </>
        )}
      </div>
      <FiChevronDown className="user-select-trigger-icon" />
    </button>
  );
};

export default UserSelectTrigger;